<template>
  <AppButton
    full-width
    class="max-w-400 m-auto w-full"
    :show-loading="showLoading"
    :disabled="disabled"
    :aria-described-by="descriptionId"
    button-type="submit"
  >
    <slot />
  </AppButton>
</template>

<script lang="ts" setup>
interface Props {
  showLoading?: boolean;
  disabled?: boolean;
  descriptionId?: string;
}

withDefaults(defineProps<Props>(), {
  showLoading: false,
  disabled: false,
  descriptionId: undefined,
});
</script>
